import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import ProductsList from '../components/ProductsList'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import {api_base_url, base_url} from '../common/Constants'; 
import { Helmet } from "react-helmet";

 

class Products extends React.Component{
  
    constructor(props){
        super(props);

        
        this.state = {
            category : [],
            loading : 1,
            slug :""
        }
    }
    componentDidMount()
    {
        
        var data = { id : this.props.params.id} 
            axios.post(api_base_url+"category", data).then(response=>{
                this.setState({category:response.data}); 
                this.setState({loading:0});
                
            }); 
    }
    componentDidUpdate(prevProps)
    {
        if(this.props.params.id !== prevProps.params.id)
        {
            var data = { id : this.props.params.id} 
            axios.post(api_base_url+"category", data).then(response=>{
                this.setState({category:response.data}); 
                this.setState({loading:0});
            }); 
        }
    }
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div>
               
                    <Header /> 
                    <Helmet>
                        <title>{this.state.category.title}</title>  
                        <meta name="description" content={this.state.category.meta_description} />
                        <meta name="keywords" content={this.state.category.meta_title} />
                        <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                        <link rel="canonical" href={base_url+'products/'+this.state.category.slug} />
                    </Helmet>
                    <PageHeader title={this.state.category.title} slug={this.props.params.id} />
                    <ProductsList slug={this.props.params.id}  />  
                    <Footer/>
                 
        
        </div>
       
        )
    }

}
export default withRouter(Products);;